<script lang="ts">
  import { cardColors } from '@athena-lib/Card/types';
  import clsx from 'clsx';
  import type { Snippet } from 'svelte';

  const { children }: { children: Snippet } = $props();
</script>

<div class={clsx(cardColors.light, 'relative h-full rounded-2xl p-gutter shadow')}>
  {@render children()}
</div>
